import { render, staticRenderFns } from "./createTfProtocolo.vue?vue&type=template&id=044110a0&scoped=true&"
import script from "./createTfProtocolo.vue?vue&type=script&lang=js&"
export * from "./createTfProtocolo.vue?vue&type=script&lang=js&"
import style0 from "./createTfProtocolo.vue?vue&type=style&index=0&id=044110a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044110a0",
  null
  
)

export default component.exports